import { Card } from '@/components/Bicester';
import { FieldArray } from 'formik';
import React from 'react';
import ServiceInfo from '../../components/ServiceInfo';
import { fetchAddEditOther, fetchOtherInfo } from '@/services/site/other';
import { defaultOtherInfo, otherSchema } from '../../Other/constants';
import { IconButton } from 'rsuite5';
import Image from '@/components/Bicester/Image';

const OtherInfo = () => {
  return (
    <ServiceInfo
      defaultServiceInfo={defaultOtherInfo}
      serviceSchema={otherSchema}
      fetchInfo={fetchOtherInfo}
      fetchEdit={fetchAddEditOther}
      getDefaultInfo={(data) => {
        return {
          other_items: data?.other_items,
        };
      }}
      getSubmitData={(id, values) =>
        Object.assign({}, values, {
          other_items: JSON.stringify(values.other_items),
          id,
        })
      }
      serviceInfo={({ formik, infoData, isEdit }) => (
        <FieldArray name="other_items">
          {({ insert, remove, push }) => (
            <>
              {formik.values.other_items.length > 0 &&
                formik.values.other_items.map((item, index) => (
                  <div key={index}>
                    <Card.Input
                      required
                      isEdit={isEdit}
                      label="服务内容"
                      formKey={`other_items.${index}.content`}
                      hasBtn={isEdit && formik.values.other_items.length > 1}
                      customBtn={
                        <IconButton
                          className={`w-[17px] h-[17px] ml-[5px] ${
                            index === 0 && formik.values.other_items.length <= 1 ? 'invisible' : ''
                          }`}
                          onClick={() => remove(index)}
                        >
                          <Image src="/resources/images/delete.svg" />
                        </IconButton>
                      }
                    />
                    <Card.Input
                      isEdit={isEdit}
                      className="flex-[3]"
                      label="登记详情"
                      formKey={`other_items.${index}.description`}
                    />
                  </div>
                ))}
              {isEdit && (
                <div className="flex">
                  <div className="flex-[3]"></div>
                  <div className="flex-[5]">
                    <IconButton
                      className="flex items-center"
                      onClick={() => push({ content: '', description: '' })}
                    >
                      <Image src="/resources/images/add.svg" />
                      <div className="text-[12px] text-[#999999] ml-[5px]">新增</div>
                    </IconButton>
                  </div>
                </div>
              )}
            </>
          )}
        </FieldArray>
      )}
    />
  );
};

export default OtherInfo;
